var l = Object.defineProperty;
var w = (r, o, t) => o in r ? l(r, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[o] = t;
var h = (r, o, t) => w(r, typeof o != "symbol" ? o + "" : o, t);
import g from "qs";
import { compile as q } from "path-to-regexp";
class y {
  constructor(o) {
    h(this, "configs");
    this.configs = { ...o };
  }
  configure(o) {
    Object.assign(this.configs, o);
  }
  getConfigs() {
    return { ...this.configs };
  }
}
const p = ({ pathTemplate: r, params: o, query: t }) => {
  const e = q(r)(o), s = g.stringify(t);
  return s ? [e, s].join("?") : e;
}, d = (r, o) => {
  const { headers: t, ...e } = o ?? {}, s = new Headers(t), n = s.get("Content-Type");
  let i, a = n;
  return r instanceof FormData || r instanceof URLSearchParams ? i = r : r && (!n || n.includes("application/json")) && (i = JSON.stringify(r), a = n ?? "application/json"), a && !n && s.set("Content-Type", a), {
    body: i,
    headers: s,
    ...e
  };
}, m = (...r) => {
  const o = new Headers();
  for (const t of r)
    new Headers(t || {}).forEach((s, n) => {
      s === void 0 || s === "undefined" ? o.delete(n) : o.set(n, s);
    });
  return o;
}, I = (r) => async (o) => r.reduce(async (t, e) => e(await t), Promise.resolve(o));
class R extends Error {
  constructor(t, e) {
    super(t);
    h(this, "name", "RequestError");
    h(this, "message");
    h(this, "status");
    h(this, "statusText");
    h(this, "text");
    this.message = t;
    const { status: s, statusText: n, text: i } = e;
    this.status = s, this.statusText = n, this.text = i;
  }
}
class T extends y {
  constructor() {
    super(...arguments);
    h(this, "interceptors", []);
    h(this, "removeRequestInterceptor", (t) => {
      this.interceptors = this.interceptors.filter((e) => e !== t);
    });
  }
  getRequestHeaders() {
    const t = {};
    return t.Accept = "application/json", this.configs.apiToken && (t.Authorization = `Bearer ${this.configs.apiToken}`), t;
  }
  addRequestInterceptor(t) {
    return this.interceptors.push(t), () => {
      this.removeRequestInterceptor(t);
    };
  }
  async request(t, e) {
    const s = new URL([this.configs.baseUrl, t].join("")), n = s.toString(), i = m(this.getRequestHeaders(), e?.headers), a = s.searchParams, u = await I(this.interceptors)({
      requestUrl: n,
      headers: i,
      queries: a,
      requestInit: e
    });
    return s.search = u.queries.toString(), fetch(s.toString(), {
      ...u.requestInit,
      headers: u.headers
    });
  }
  // eslint-disable-next-line class-methods-use-this
  async throwIfNotOk(t) {
    if (t.ok) return;
    let e;
    try {
      e = await t.text();
    } catch {
    }
    throw new R("Request Failed", {
      text: e,
      status: t.status,
      statusText: t.statusText
    });
  }
  async get({ pathTemplate: t, params: e, query: s }, n) {
    const i = p({ pathTemplate: t, params: e, query: s }), a = await this.request(i, { method: "GET", ...n });
    return await this.throwIfNotOk(a), a.status !== 204 ? await a.json() : null;
  }
  async post({ pathTemplate: t, params: e, query: s, data: n }, i) {
    const a = p({ pathTemplate: t, params: e, query: s }), u = d(n, i), c = await this.request(a, { method: "POST", ...u });
    return await this.throwIfNotOk(c), c.status !== 204 ? await c.json() : null;
  }
  async put({ pathTemplate: t, params: e, query: s, data: n }, i) {
    const a = p({ pathTemplate: t, params: e, query: s }), u = d(n, i), c = await this.request(a, { method: "PUT", ...u });
    return await this.throwIfNotOk(c), c.status !== 204 ? await c.json() : null;
  }
  async patch({ pathTemplate: t, params: e, query: s, data: n }, i) {
    const a = p({ pathTemplate: t, params: e, query: s }), u = d(n, i), c = await this.request(a, { method: "PATCH", ...u });
    return await this.throwIfNotOk(c), c.status !== 204 ? await c.json() : null;
  }
  async delete({ pathTemplate: t, params: e, query: s, data: n }, i) {
    const a = p({ pathTemplate: t, params: e, query: s }), u = d(n, i), c = await this.request(a, { method: "DELETE", ...u });
    return await this.throwIfNotOk(c), c.status !== 204 ? await c.json() : null;
  }
}
class O extends T {
  constructor() {
    super(...arguments);
    h(this, "clients", []);
    h(this, "addRequestInterceptor", (t) => {
      const e = super.addRequestInterceptor(t), s = this.clients.map((n) => n.addRequestInterceptor(t));
      return () => {
        e(), s.forEach((n) => n());
      };
    });
  }
  configure(t) {
    super.configure(t), this.clients.forEach((e) => e.configure(t));
  }
}
export {
  T as BaseClient,
  O as BaseRootClient,
  y as Configurable,
  R as RequestError
};
//# sourceMappingURL=base-api-client.js.map
